import React, { useState } from 'react'
import styled from 'styled-components'
const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
const arrows =
  "url('data:image/svg+xml;utf8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%2050%2067%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill%3D%22none%22%20stroke-width%3D%222%22%3E%3Cline%20x1%3D%221%22%20x2%3D%2250%22%20y1%3D%2233.5%22%20y2%3D%2233.5%22%20stroke%3D%22%23f0f0f2%22%2F%3E%3Cpolyline%20transform%3D%22translate(25%2020)%20rotate(45)%20translate(-25%20-20)%22%20points%3D%2219%2026%2019%2014%2032%2014%22%20stroke%3D%22%23000%22%2F%3E%3Cpolyline%20transform%3D%22translate(25%2045)%20rotate(225)%20translate(-25%20-45)%22%20points%3D%2219%2052%2019%2039%2032%2039%22%20stroke%3D%22%23000%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E')"
const isMobile = window.innerWidth < 712

const StyledNumberInput = styled.div``
const StyledInput = styled.input<{
  disabled: boolean
}>`
  font-size: 18px;
  padding: 10px;
  width:80%;
  height: 50px;
  border-radius: 0;
  outline: none;
  border: 0;

  border-bottom: 1px solid var(--brandblue-main);
  text-align: center;

  background-color: white;
  color:#202346;
  /* background-image: ${({ disabled }) =>
    !disabled && !isMobile && !isFirefox ? arrows : undefined};
  background-position: center right;
  background-size: contain;
  background-repeat: no-repeat;
  caret-color: transparent; */

  -moz-appearance: textfield;
  appearance: textfield;
`

export const NumberInput = ({
  min = 0,
  max = 100,
  id,
  current,
  change,
  disabled
}: {
  min?: number
  max?: number
  id: string | number
  current: number
  disabled: boolean
  change: (value: number) => void
}) => {
  const handleFocus = event => event.target.select()
  return (
    <StyledNumberInput className='NumberInput'>
      <StyledInput
        onFocus={handleFocus}
        type={disabled || isMobile ? 'text' : 'number'}
        pattern='[0-9]*'
        onChange={e => {
          let num = +e.target.value

          change(num)
        }}
        min={min}
        max={max}
        id={id + ''}
        name={id + ''}
        value={+current}
        disabled={disabled}
      />
    </StyledNumberInput>
  )
}
